import * as _ from 'lodash';
import { default as Bluebird } from 'bluebird';
import { EventEmitter } from 'events';

declare let Utils: any;
declare var Ext: any;
declare const StoreUtils: any;

export type BreakingChangeRecord = {
    affectedStore: string;
    originDescriptor: string;
    details: object;
}
export class BaseDescriptor extends EventEmitter {
    name: string = 'BaseDescriptor';

    introducedIn: string;

    affectedStore: string;

    dependencyStores: string[] = [];

    rules: Array<(params?: any[]) => { created?: BreakingChangeRecord, fixed?: BreakingChangeRecord }> = [];

    isAffectingCurrentVersion(): boolean {
        return this.introducedIn <= Utils.getVersion();
    }

    async showAlertNotification() {
        this.emit('notificationClosed');
    }

    async runCheck(suppressAlert: boolean = false): Promise<void> {
        if (!this.isAffectingCurrentVersion()) {
            return;
        }
        await this.loadDependencyStores();
        const breakRecordStore = Ext.getStore('BreakingChange');
        const existingRecords = breakRecordStore.getRecordsByFilter('originDescriptor', this.name);
        this.rules.forEach(rule => {
            const { created, fixed } = rule();
            if (created && !existingRecords.find(existing => _.isEqual(_.omit(existing.data, 'id'), created))) {
                breakRecordStore.add(created);
            }
            const recordInStore = existingRecords.find(existing => _.isEqual(_.omit(existing.data, 'id'), fixed));
            if (recordInStore) {
                breakRecordStore.remove(recordInStore);
            }
        });
        breakRecordStore.syncWithListener(() => {
            if (!suppressAlert && breakRecordStore.getRecordsByFilter('originDescriptor', this.name).length) {
                this.emit('showNotification');
            }
        });
    }

    async loadDependencyStores(): Promise<void> {
        await Bluebird.each(this.dependencyStores, async storeName => {
            await StoreUtils.getStoreAndLoad(storeName);
        });
    }

    createChangeRecord(details?: Record<string, any>): BreakingChangeRecord {
        return {
            affectedStore: this.affectedStore,
            originDescriptor: this.name,
            details: { ...details },
        };
    }
}
